export const SelectionTypes = {
  PlanningBlock: 'planningBlock',
  TransportOrder: 'transportOrder',
  OrderLine: 'orderline',
} as const;

export type SelectionType = typeof SelectionTypes[keyof typeof SelectionTypes];
